<template>
  <div
    :class="['peer-view', {
      'bordered is-active-speaker': isActiveSpeaker,
      'bordered is-raised-hands': isRaisedHands,
      'bordered is-screen-sharer': isScreenSharer
    }]"
  >
    <div class="peer-avatar">
      <img :src="avatar || require('@/assets/images/avatar_default.png')"/>
    </div>
    <video
      :srcObject.prop="videoStream"
      autoplay
      muted
      playsinline
      disablePictureInPicture
      class="peer-video"
    />
    <audio
      v-if="!myself"
      :srcObject.prop="audioStream"
      autoplay
    />
    <div v-if="displayIcon" :class="['peer-view-assets', { 'myself': myself }]">
      <span
        v-if="isRaisedHands"
        class="is-raised-hands"
        @click="$emit('onClickRaisedHands')"
      >
        <img :src="require('@/assets/images/room/icons/raised_hands_sm.png')"/>
      </span>
      <span v-if="isActiveSpeaker" class="mic-on active">
        <span class="mic-on-icon"/>
      </span>
      <span
        v-else-if="micState"
        class="mic-icon"
        @click="$emit('onClickMicState')"
      >
        <img :src="require('@/assets/images/room/icons/mic_on_sm.png')"/>
      </span>
      <span
        v-else
        class="mic-icon"
        @click="$emit('onClickMicState')"
      >
        <img :src="require('@/assets/images/room/icons/mic_off_sm.png')"/>
      </span>
      <span class="display-name">{{ displayName }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PeerView',
  props: {
    myself: Boolean,
    avatar: String,
    displayName: String,
    videoStream: MediaStream,
    audioStream: MediaStream,
    micState: Boolean,
    isActiveSpeaker: Boolean,
    isRaisedHands: Boolean,
    isScreenSharer: Boolean,
    displayIcon: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.peer-view {
  position: relative;
  background-color: #282828;

  &.bordered {
    &:after {
      pointer-events: none;
      content: "";
      position: absolute;
      display: block;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &.is-active-speaker:after, &.is-screen-sharer:after {
      border: 6px solid white;
    }

    &.is-raised-hands:after {
      border: 6px solid #FF0000;
    }

    &.is-screen-sharer {
      position: absolute;
      top: 0;
    }
  }
}

.peer-avatar {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 20%;
    height: auto;
    object-fit: cover;
    border-radius: 50%;
    box-shadow: 0px 0px 8px white;
  }
}

.peer-video {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.peer-view-assets {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 15px;

  &:not(.myself) {
    pointer-events: none;
  }

  .mic-on, .mic-icon, .is-raised-hands {
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
  }

  .mic-on {
    position: relative;

    .mic-on-icon {
      &, &:before, &:after {
        content: '';
        display: block;
        position: absolute;
        width: 2px;
        height: 15px;
        left: 0;
        background: white;
      }

      &:before {
        left: 7px;
      }

      &:after {
        left: 14px;
      }
    }

    &.active .mic-on-icon {
      animation: 0.5s ease-in infinite alternate running scale-y;

      &:before {
        animation: 0.2s ease-in infinite alternate running scale-y;
      }

      &:after {
        animation: 0.3s ease-in infinite alternate running scale-y;
      }
      @keyframes scale-y {
        0% {
          transform: scaleY(0);
        }
        100% {
          transform: scaleY(1.2);
        }
      }
    }
  }

  .mic-icon, .is-raised-hands {
    cursor: pointer;
    border-radius: 50%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .display-name {
    flex: 1;
    font-size: 13px;
    font-weight: 600;
    color: white;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
